//LIBRERIES
import { createApp, defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { i18n } from '../lang/index';
import { useI18n } from 'vue-i18n';

//MODELS
import { App } from "../domain/App";
import { Cookie } from "../domain/Cookie";
import { Languages } from "../domain/enum/Languages";
import { Constants } from "../domain/enum/Constants";
import ICommonDataState from '../domain/interfaces/ICommonDataState';

//APISERVICES
import { getHeaderConfiguration, getClientAvailableLanguajes, getFeatureFlag } from "../infrastructure/apiServices/masterData.service";

//COMPOSABLES
import { useCommonData } from "./composables/useCommonData";
import { useIncidences } from "./composables/useIncidences";

export const NotFoundComponent = defineComponent({
  setup() {
    // dependencies
    const { t, locale } = useI18n();

    // states
    const commonDataState = reactive({
      headerConfig: {},
      availableLanguajes: { defaultLanguage: '', secondLanguage: ''},
      cookie: new Cookie(),
      app: new App(),
      locale
    });
    
    // shared properties
    const showMandatoryCookies = ref(false);
    const showAnalysisCookies = ref(false);
    const showModalConfigurateCookies = ref(false);
    
    // view properties
    const myInscriptionsList = ref([]);
    
    // methods
    const getAllData = () => {
      commonDataState.app.getProfile();
    };

    const changeLocal = (language) => {
      commonDataState.locale = language;
      commonDataState.app.changeLanguaje(language);
    };
    const saveCookies = () => {
      commonDataState.cookie.savePersonalizateCookies();
      showModalConfigurateCookies.value = false;
    };

    const closeModalConfigurateCookies = () => {
      showModalConfigurateCookies.value = false;
    };

    const acceptAllCookies = () => {
      commonDataState.cookie.acceptAllCookies();
    };

    const declineAllCookies = () => {
      commonDataState.cookie.declineAllCookies();
    };

    const updateCommonData = (state: ICommonDataState) => {
      commonDataState.availableLanguajes = state.availableLanguajes;
      commonDataState.cookie = state.cookie;
      commonDataState.headerConfig = state.headerConfig;
      commonDataState.app = state.app;
      commonDataState.locale = state.locale;

      getAllData();
    };
    
    // composables
    const useCommonDataDependencies = {
      updateCommonData,
      getHeaderConfiguration,
      getFeatureFlag,
      getClientAvailableLanguajes,
    };
    const { loadCommonData } = useCommonData(useCommonDataDependencies);
    const { incidence, showNotificationIncidence, IncidencesTypes, closeIncidence} = useIncidences();

    onMounted(() => {
      loadCommonData();
    });
    
    return {
      // dependencies
      t,
      Languages: Languages,
      // states
      ...toRefs(commonDataState),
      // shared view properties
      showMandatoryCookies,
      showAnalysisCookies,
      showModalConfigurateCookies,
      pageTitle: '',
      // methods
      getAllData,
      saveCookies,
      closeModalConfigurateCookies,
      acceptAllCookies,
      declineAllCookies,
      changeLocal,
      closeIncidence,
      // view properties
      myInscriptionsList,
      incidence,
      showNotificationIncidence,
      IncidencesTypes
    }
  }
});

const vueApp = createApp(NotFoundComponent);
vueApp.use(i18n);
vueApp.config.compilerOptions.whitespace = 'preserve';
vueApp.mount(Constants.APP);